const customersTheme = {
  '5ce5e06d2a311a13c55505b9': {
    name: 'Stage',
    theme: 'pink darken-4',
    colorHTML: '#880E4F',
    logo: 'https://cdn.clinic.inf.br/public/images/new-clinic.png',
    cssClass: 'backgroud-logo-spitzer'
  },

  '5f03ac45ee42d49e97146c3f': {
    name: 'Stage',
    theme: 'pink darken-4',
    colorHTML: '#880E4F',
    logo: 'https://cdn.clinic.inf.br/public/images/new-clinic.png',
    cssClass: 'backgroud-logo-spitzer'
  },

  // '5a9ac06729b69d13c076cc41': {
  //   name: 'Online-IPO',
  //   theme: 'pink darken-4',
  //   colorHTML: '#880E4F',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-ipo.png',
  //   cssClass: 'backgroud-logo-ipo'
  // },
  '5aa5af745757da74a00d9138': {
    name: 'Online-Altclin',
    theme: 'red darken-4',
    colorHTML: '#d32f2f',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-alticlin.png',
    cssClass: 'backgroud-logo-alticlin'
  },
  '5ab94676e9fb5d49ae9bc641': {
    name: 'Online-Iguacu',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-iguacu.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  // '5ac6894e806793790864e9db': {
  //   name: 'Online-Ophtalmus',
  //   theme: 'indigo darken-2',
  //   colorHTML: '#303F9F',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-ophtalmus.png',
  //   cssClass: 'backgroud-logo-ophtalmus'
  // },
  '5adf40811bfbf60c10d53d72': {
    name: 'Online-Barigui',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-barigui.png',
    cssClass: 'backgroud-logo-barigui'
  },
  // '5b0d63a420fbbb0f70e77c26': {
  //   name: 'Online-CliniDerma',
  //   theme: 'orange darken-3',
  //   colorHTML: '#EF6C00',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-cliniderma.png',
  //   cssClass: 'backgroud-logo-cliniderma'
  // },
  '5b0d65f320fbbb0f70e77c27': {
    name: 'Online-Hosp-SaoLucas',
    theme: 'blue lighten-1',
    colorHTML: '#42a5f5',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-saolucas.png',
    cssClass: 'backgroud-logo-hosp-saolucas'
  },
  '5af4a0f420fbbb0f70e7743a': {
    name: 'Online-Clinica-Adel-Bark',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-adel-bark.png',
    cssClass: 'backgroud-logo-hosp-saolucas'
  },
  '5aa5ab0e7919573958da8833': {
    name: 'Online-Otorrinos-Curitiba',
    theme: 'brown lighten-4',
    colorHTML: '#D7CCC8',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-otorrinos.png',
    cssClass: 'backgroud-logo-otorrinos'
  },
  '5b3e227df84fc9467e0ef6de': {
    name: 'Online-Porto-seguro',
    theme: 'orange darken-3',
    colorHTML: '#EF6C00',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-porto-seguro.png',
    cssClass: 'backgroud-logo-porto-seguro'
  },
  '5bacec3633ab500ff7c96007': {
    name: 'Online-Oftalmoclinica-Curitiba',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-oftalmocuritiba.png',
    cssClass: 'backgroud-logo-oftalmoclinica-curitiba'
  },
  '5be1cede33ab500ff7c974ba': {
    name: 'Online-Alcides-Branco',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-alcidesbranco.png',
    cssClass: 'backgroud-logo-alcides-branco'
  },
  '5ac68816806793790864e9d5': {
    name: 'Online-Instituto-Crianca',
    theme: 'blue lighten-1',
    colorHTML: '#42a5f5',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-crianca.png',
    cssClass: 'backgroud-logo-instituto-crianca'
  },
  '5c9cb6fbaf1b077717153d74': {
    name: 'Online-Costa-Claro',
    theme: 'amber lighten-2',
    colorHTML: '#FFD54F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-costa-claro.png',
    cssClass: 'backgroud-logo-costa-claro'
  },
  // '5d137731c35f0e6e45ab549e': {
  //   name: 'Online-Inga-COI',
  //   theme: 'indigo darken-2',
  //   colorHTML: '#303F9F',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-inga-coi.png',
  //   cssClass: 'backgroud-logo-inga-coi'
  // },
  '5d38a6c8bf9ff07fcd3c1fc6': {
    name: 'Online-Poli-Fazenda',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-poli-fazenda.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5d5aee56bf9ff07fcd3c2df9': {
    name: 'Online-Jardim-Americas',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-centro-medico-sjda.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5ca259b2af1b07771715409b': {
    name: 'Online-Pulmonar',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-pulmonar.webp',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5e382ee8f0ad900810aefb56': {
    name: 'Online-Ortoclinica',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://storage.googlv12.22.5eapis.com/spitzer-risc-logos/logo_otoclinica_editado.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5e503a56462560492f99a1e1': {
    name: 'Online-Cedac',
    theme: 'red darken-4',
    colorHTML: '#d32f2f',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-cedac.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5efa3ec74d34bf5a9865bbcf': {
    name: 'Online-Climm',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-climm.JPG',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5b6a011ede520c621a0bdb29': {
    name: 'Online-ARTRO',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-artro-white.svg',
    cssClass: 'backgroud-logo-artro'
  },
  '5e736368769e710930a3e597': {
    name: 'Online-SAKATO',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-sakata.png',
    cssClass: 'backgroud-logo-artro'
  },
  '5f50f33367657c4ccd58f847': {
    name: 'Online-IMOF',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-imof.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5f7db55feb97640d5d5e5236': {
    name: 'Online-ANDROLAB',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-androlab-new.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5edfe54ec2ded3227d18ff14': {
    name: 'Online-INC',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-inc.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5fd0fb55d788e61c704abb76': {
    name: 'Online-INC',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-uroclinica.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5fc4f0f2c5911e3f09ce250d': {
    name: 'Online-IPO-Dermato',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-ipo.png',
    cssClass: 'backgroud-logo-ipo'
  },
  '60073cd668d7f96a37455ff5': {
    name: 'Online-Cepelle',
    theme: 'pink darken-4',
    colorHTML: '#880E4F',
    logo: 'http://cepelle.com.br/wp-content/uploads/2020/04/thumbnail_logo.png',
    cssClass: 'backgroud-logo-ipo'
  },
  '6022c29bd01ce52fbc087204': {
    name: 'Online-Ballin',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-ballin.jpeg',
    cssClass: 'backgroud-logo-ipo'
  },
  '5c4f406a7fc6ce4155ace08e': {
    name: 'Online-Inccor',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-incor.JPG',
    cssClass: 'backgroud-logo-ipo'
  },
  '6040d7ead01ce52d19087870': {
    name: 'Online-CLINICA-JUK-BENKE-CLINICA-FAGUNDES',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-juk-benke.png',
    cssClass: 'backgroud-logo-ipo'
  },
  '5f72240fd168833f71c7a34d': {
    name: 'Online-Immef',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-immef.svg',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5f19db3d6aabc95bc449cc4c': {
    name: 'CLINICA-DE-CONTI',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-conti.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '60885c7aabd9fc633734cf53': {
    name: 'UNION-CEMOC',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-union-cemoc.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '60c764fe9144fdac6a6bf5db': {
    name: 'SORAYA',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-soroya.png',
    cssClass: 'backgroud-logo-spitzer'
  },
  '6108456d772b6c1a983c87ad': {
    name: 'Online-Cleusa-canan',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-clinica-cleuza-canan.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5ac68838806793790864e9d6': {
    name: 'Online-Ivisao',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-ivisao.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '61fbd6a32274318541502871': {
    name: 'COP - CLÍNICA DE OLHOS E PÁLPEBRAS JARDIM AMBIENTAL',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-poc-palpebras-e-olhos.jpg',
    cssClass: 'backgroud-logo-iguacu'
  },
  '6112799f18ba88250a32845f': {
    name: 'MEDSUL',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-medsul.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '627e912c197f9a3164daf043': {
    name: 'CLINICA SAO VICENTE',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-csv.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '628f7d2edd0fc258ba26d5e5': {
    name: 'INSTITUTO DO APARELHO DIGESTIVO',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-iad.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5e381ef2f0ad900810aefb3c': {
    name: 'CLÍNICA HARMONIA',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-harmonia.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '620e934826d34466d05951d2': {
    name: 'STELLA MARIS',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-clinic.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5e4ee35b462560492f99a162': {
    name: 'STAGE',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-clinic.png',
    cssClass: 'backgroud-logo-iguacu'
  },
}

export default customersTheme



//////////////////
// WEBPACK FOOTER
// ./config/customersTheme.js
// module id = null
// module chunks = 